import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CaseStudiesSection = () => {
  const [activeCase, setActiveCase] = useState(0);

  const caseStudies = [
    {
      title: 'Technology Startup Valuation',
      industry: 'Fintech',
      type: 'Pre-Series B Funding',
      challenge: 'A rapidly growing fintech startup needed an independent valuation for Series B funding negotiations. The company had complex revenue recognition issues and significant intangible assets.',
      approach: [
        'Applied DCF methodology with multiple scenarios',
        'Conducted extensive market comparables analysis',
        'Valued intellectual property and technology platform',
        'Assessed regulatory compliance and risk factors'
      ],
      outcome: {
        value: '$28M',
        timeline: '3 weeks',
        result: 'Successfully supported $15M Series B funding round at favorable terms'
      },
      metrics: [
        { label: 'Revenue Multiple', value: '8.5x' },
        { label: 'Growth Rate', value: '180%' },
        { label: 'Market Position', value: 'Top 3' }
      ],
      testimonial: {
        quote: "The valuation was comprehensive and defensible. It gave us confidence in our negotiations and helped secure the funding we needed.",
        author: "John Doe",
        position: "CEO, FinanceFlow"
      }
    },
    {
      title: 'Family Business Succession',
      industry: 'Manufacturing',
      type: 'Estate Planning',
      challenge: 'A third-generation family manufacturing business needed valuation for succession planning and estate tax purposes. Complex ownership structure with multiple family members.',
      approach: [
        'Asset-based approach for manufacturing assets',
        'Income approach for ongoing operations',
        'Minority interest and marketability discounts',
        'Tax optimization strategies'
      ],
      outcome: {
        value: '$45M',
        timeline: '4 weeks',
        result: 'Enabled tax-efficient succession plan saving $3.2M in estate taxes'
      },
      metrics: [
        { label: 'Asset Value', value: '$52M' },
        { label: 'Tax Savings', value: '$3.2M' },
        { label: 'Family Harmony', value: 'Preserved' }
      ],
      testimonial: {
        quote: "The team understood our family dynamics and provided a fair valuation that all stakeholders accepted. The succession went smoothly.",
        author: "John Doe",
        position: "Chairman, Doe Industries"
      }
    },
    {
      title: 'Acquisition Due Diligence',
      industry: 'Healthcare',
      type: 'Strategic Acquisition',
      challenge: 'A healthcare services company was acquiring a chain of medical clinics. Needed independent valuation to support acquisition price and identify value creation opportunities.',
      approach: [
        'Market approach using healthcare transaction data',
        'Income approach with synergy adjustments',
        'Asset approach for medical equipment',
        'Risk assessment for regulatory changes'
      ],
      outcome: {
        value: '$18M',
        timeline: '2 weeks',
        result: 'Identified $2.1M in synergies and supported successful acquisition'
      },
      metrics: [
        { label: 'EBITDA Multiple', value: '6.2x' },
        { label: 'Synergies Identified', value: '$2.1M' },
        { label: 'ROI Projection', value: '22%' }
      ],
      testimonial: {
        quote: "The valuation helped us understand the true value and negotiate a fair price. The synergy analysis was particularly valuable.",
        author: "Dr. John Doe",
        position: "CEO, Doe Industries"
      }
    },
    {
      title: 'Litigation Support',
      industry: 'Real Estate',
      type: 'Shareholder Dispute',
      challenge: 'Shareholder dispute in a real estate development company required independent valuation for court proceedings. Complex joint venture structures and disputed asset values.',
      approach: [
        'Independent asset appraisals',
        'Market analysis of comparable developments',
        'Cash flow modeling for ongoing projects',
        'Expert testimony preparation'
      ],
      outcome: {
        value: '$75M',
        timeline: '5 weeks',
        result: 'Court accepted valuation methodology, leading to fair settlement'
      },
      metrics: [
        { label: 'Asset Portfolio', value: '$85M' },
        { label: 'Disputed Amount', value: '$12M' },
        { label: 'Settlement', value: 'Achieved' }
      ],
      testimonial: {
        quote: "The expert testimony was clear and convincing. The court fully accepted the valuation methodology and conclusions.",
        author: "John Doe",
        position: "Partner, Doe Legal"
      }
    }
  ];

  const successMetrics = [
    { label: 'Cases Completed', value: '150+', icon: 'FileCheck' },
    { label: 'Average Timeline', value: '3.2 weeks', icon: 'Clock' },
    { label: 'Court Acceptance Rate', value: '95%', icon: 'Scale' },
    { label: 'Client Satisfaction', value: '98%', icon: 'Heart' }
  ];

  return (
    <>
      {/* <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-primary mb-6">
            Success Stories
          </h2>
          <p className="text-xl text-text-secondary leading-relaxed">
            Real-world examples of how our valuation expertise has supported critical business decisions across diverse industries and transaction types.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-6 mb-16">
          {successMetrics?.map((metric, index) => (
            <div key={index} className="text-center p-6 bg-muted rounded-xl">
              <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <Icon name={metric?.icon} size={24} className="text-accent" />
              </div>
              <div className="text-2xl font-bold text-primary mb-2">{metric?.value}</div>
              <div className="text-sm text-text-secondary">{metric?.label}</div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-4 mb-8 justify-center">
          {caseStudies?.map((study, index) => (
            <button
              key={index}
              onClick={() => setActiveCase(index)}
              className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                activeCase === index
                  ? 'bg-accent text-white shadow-brand'
                  : 'bg-muted text-text-primary hover:bg-accent/10 hover:text-accent'
              }`}
            >
              {study?.industry}
            </button>
          ))}
        </div>

        <div className="bg-muted rounded-2xl p-8">
          {caseStudies?.map((study, index) => (
            activeCase === index && (
              <div key={index}>
                <div className="grid lg:grid-cols-3 gap-8 mb-8">
                  <div className="lg:col-span-2">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="px-3 py-1 bg-accent/10 text-accent text-sm font-medium rounded-full">
                        {study?.industry}
                      </div>
                      <div className="px-3 py-1 bg-success/10 text-success text-sm font-medium rounded-full">
                        {study?.type}
                      </div>
                    </div>
                    <h3 className="text-2xl font-bold text-primary mb-4">{study?.title}</h3>
                    <p className="text-text-secondary leading-relaxed">{study?.challenge}</p>
                  </div>
                  
                  <div className="bg-white rounded-xl p-6">
                    <h4 className="font-semibold text-primary mb-4">Key Metrics</h4>
                    <div className="space-y-3">
                      {study?.metrics?.map((metric, idx) => (
                        <div key={idx} className="flex justify-between items-center">
                          <span className="text-text-secondary text-sm">{metric?.label}</span>
                          <span className="font-semibold text-primary">{metric?.value}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="grid lg:grid-cols-2 gap-8 mb-8">
                  <div className="bg-white rounded-xl p-6">
                    <h4 className="text-lg font-semibold text-primary mb-4 flex items-center">
                      <Icon name="Target" size={20} className="text-accent mr-2" />
                      Our Approach
                    </h4>
                    <ul className="space-y-3">
                      {study?.approach?.map((item, idx) => (
                        <li key={idx} className="flex items-start space-x-3">
                          <Icon name="CheckCircle" size={16} className="text-success flex-shrink-0 mt-0.5" />
                          <span className="text-sm text-text-primary">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-white rounded-xl p-6">
                    <h4 className="text-lg font-semibold text-primary mb-4 flex items-center">
                      <Icon name="TrendingUp" size={20} className="text-success mr-2" />
                      Outcome & Impact
                    </h4>
                    <div className="space-y-4">
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-3 bg-accent/5 rounded-lg">
                          <div className="text-lg font-bold text-accent">{study?.outcome?.value}</div>
                          <div className="text-xs text-text-secondary">Valuation</div>
                        </div>
                        <div className="text-center p-3 bg-success/5 rounded-lg">
                          <div className="text-lg font-bold text-success">{study?.outcome?.timeline}</div>
                          <div className="text-xs text-text-secondary">Delivery</div>
                        </div>
                      </div>
                      <p className="text-sm text-text-primary">{study?.outcome?.result}</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon name="Quote" size={20} className="text-accent" />
                    </div>
                    <div className="flex-1">
                      <blockquote className="text-lg text-text-primary mb-4 italic">
                        "{study?.testimonial?.quote}"
                      </blockquote>
                      <div className="flex items-center space-x-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-accent to-accent/70 rounded-full flex items-center justify-center">
                          <span className="text-white font-semibold text-sm">
                            {study?.testimonial?.author?.split(' ')?.map(n => n?.[0])?.join('')}
                          </span>
                        </div>
                        <div>
                          <div className="font-semibold text-primary">{study?.testimonial?.author}</div>
                          <div className="text-sm text-text-secondary">{study?.testimonial?.position}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-accent/10 to-primary/10 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-primary mb-4">
              Ready to Start Your Valuation?
            </h3>
            <p className="text-text-secondary mb-6 max-w-2xl mx-auto">
              Join our satisfied clients who have benefited from our professional valuation services. 
              Let's discuss how we can support your business objectives.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="default"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
              >
                Free Consultation
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="FileText"
                iconPosition="left"
              >
                View All Case Studies
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section> */}
    </>
  );
};

export default CaseStudiesSection;